import actions from './_actions';
import getters from './_getters';
import mutations from './_mutators';

const state = {
    levels: [],
    isLoading: false,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/taskflex/levels/store/index.js